// src/pages/Pricing/PaymentSuccess.jsx
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
// You'll need an API function to verify the payment
// import { verifyStripePayment } from '../../services/api';

const PaymentSuccess = () => {
    const { t } = useTranslation();
    const { fetchUser } = useAuth();
    const [searchParams] = useSearchParams();
    
    useEffect(() => {
        const sessionId = searchParams.get('session_id');
        const verifyPayment = async () => {
            if (sessionId) {
                // In a real app, you would send this sessionId to your backend
                // to verify the payment and update credits.
                // await verifyStripePayment(sessionId);
                
                // For now, we just refresh the user's data to get new credit balance
                fetchUser();
            } else {
                 // For PayPal, we don't get a session ID, just refresh user data
                 fetchUser();
            }
        };
        verifyPayment();
    }, [searchParams, fetchUser]);

    return (
        <div className="min-h-screen bg-brand-dark flex items-center justify-center text-white">
            <div className="text-center p-8 bg-slate-800 rounded-lg">
                <CheckCircle className="mx-auto h-16 w-16 text-green-400" />
                <h1 className="mt-4 text-3xl font-bold">{t('payment.successTitle')}</h1>
                <p className="mt-2 text-slate-300">{t('payment.successDesc')}</p>
                <Link to="/account" className="mt-8 inline-block px-6 py-2 bg-brand-orange rounded-md font-semibold">
                    {t('payment.goToAccount')}
                </Link>
            </div>
        </div>
    );
};

export default PaymentSuccess;